import type { ClientEquipmentItem } from '@game/shared-types';
import { Skeleton } from '@game/ui';
import type { JSX } from 'react';
import { useMedia } from 'react-use';

import { breakpoints } from '@constants/breakpoints';
import { qualityColor } from '@constants/maps';

export const EquipmentSkeleton = ({ item }: { item: ClientEquipmentItem }): JSX.Element => {
  const isMobile = useMedia(`(max-width: ${breakpoints.md}px)`);
  const equipmentSize = isMobile ? 70 : 42;

  return (
    <Skeleton
      src={item.item.imageUrl}
      width={equipmentSize}
      height={equipmentSize}
      style={{
        border: `2px solid ${qualityColor[item.quality]}`,
        borderRadius: '5px',
        boxShadow: '2px 2px 2px 1px rgba(0, 0, 0, 0.2)',
      }}
      alt={item.item.name}
    />
  );
};
